function CampaignClosed() {
  const campaignClosedText: any = {
    campaignClosed: "Campaign closed",
    title: "Final Results Coming Soon...",
    titleFinal: "The Results Are In!",
    desc: "Thanks for taking part! Your referrals are now being reviewed before we publish the final results.",
  };

  {
    /*TODO - add dynamic value*/
  }
  const isFinal = false;

  return (
    <div className={"font-jost mb-6 lg:max-w-[530px] lg:mx-auto"}>
      <div className={"flex items-center gap-6.5 mb-6 lg:gap-2"}>
        <div>
          {!isFinal ? (
            <img
              className={"w-[68px] lg:w-[100px] h-auto"}
              src={"/assets/images/refer-a-friend/medal.png"}
              alt={"medal"}
            />
          ) : (
            <img
              className={"w-[68px] lg:w-[100px] h-auto"}
              src={"/assets/images/refer-a-friend/final-cup.png"}
              alt={"cup"}
            />
          )}
        </div>
        <div>
          <div
            className={
              "bg-red-1 px-2 py-0.5 h-5 lg:h-[30px] rounded uppercase flex-center text-center text-[11px] lg:text-base text-white font-medium leading-3.5 lg:leading-5.5 mb-[7px] lg:mb-[17px]"
            }>
            {campaignClosedText.campaignClosed}
          </div>
          <div
            className={`text-dark-1 text-xl leading-6.5 font-semibold ${!isFinal ? "max-lg:max-w-36" : "max-lg:max-w-48"}`}>
            {!isFinal ? campaignClosedText.title : campaignClosedText.titleFinal}
          </div>
        </div>
      </div>
      <div className={"text-center text-xs lg:text-lg text-gray-1 leading-4 lg:leading-6 font-normal"}>
        {campaignClosedText.desc}
      </div>
    </div>
  );
}

export default CampaignClosed;
